import React from "react";
import {
  DisplayHeading,
  Text,
  FullWrapper,
  Span,
  Flex,
  ExternalLink
} from "../components/Primitives";

import ScrollPage from "../components/ScrollPage";

import { getRatio16to9 } from "../utils/getRatio16to9";

const Striked = props => (
  <Span
    color="lines"
    fontWeight="2"
    css={{ textDecoration: "line-through" }}
    {...props}
  />
);
const Highlight = props => (
  <Span color="accentBlue" fontWeight="2" {...props} />
);
const AboutLink = props => (
  <ExternalLink
    color="white"
    fontWeight="2"
    css={{ textDecoration: "underline" }}
    {...props}
  />
);
export const About = ({ ...props }) => {
  const firstRatio = getRatio16to9(100);
  const secondRatio = getRatio16to9(firstRatio);
  const thirdRatio = getRatio16to9(secondRatio);
  const marginLeft = firstRatio - thirdRatio;
  return (
    <ScrollPage>
      <FullWrapper flexDirection="column">
        <Flex ml={[0, 6, `${marginLeft}vh`]} flexDirection="column">
          <DisplayHeading color="accentPurple">Hello</DisplayHeading>
          <Text pb="1">
            I'm Daniel Velasquez, <Highlight>Front-end developer</Highlight> &
            generative art <Striked>connoisseur</Striked> based in Florida,
            helping companies deliver experiences & happines to their users.
            <br />
            <br />I make use of code design & creativity to develop maintainable
            code, and deliver responsive, accessible experiences to the end user
            :)
            <br />
            <br />
            Nowadays, I am <Highlight>freelancing full-time</Highlight>, feel
            free to reach out!
          </Text>
          <Text>
            <AboutLink href="mailto:velasquezdanield@gmail.com" fontSize="2">
              velasquezdanield@gmail.com
            </AboutLink>
            <Flex>
              <AboutLink href="https://twitter.com/Anemolito" pr={2}>
                Twitter
              </AboutLink>
              <AboutLink href="https://codesandbox.io/u/Anemolo" pr={2}>
                Code Sanbox
              </AboutLink>
              <AboutLink href="https://github.com/Anemolo">Github</AboutLink>
            </Flex>
          </Text>
        </Flex>
      </FullWrapper>
    </ScrollPage>
  );
};
